import { Box, Button, Flex, keyframes, Link, useBreakpointValue } from '@chakra-ui/react'
import ArrowRightOmens from 'components/svg/ArrowRightOmens'
import { Body1 } from 'components/typography'
import { ONBOARDING_INITIAL_STEP } from 'constants/onboarding'
import { HERO_SECTION_ID } from 'layouts/LadingLayout/components/Navbar/components/NavbarDesktop'
import { FC, useEffect, useState } from 'react'

const arrowNudge = keyframes`
  0%, 60%, 100% { transform: translateX(0); }
  20% { transform: translateX(8px); }
  40% { transform: translateX(0); }
`

const MedleveStickyCTA: FC = () => {
  const isMobile = useBreakpointValue({ base: true, lg: false })
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    setVisible(false)
    if (!isMobile) return
    const heroEl = document.getElementById(HERO_SECTION_ID)
    if (!heroEl) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Show the sticky CTA when the hero is NOT intersecting (user scrolled past it)
        setVisible(!entry.isIntersecting)
      },
      // Negative top rootMargin shrinks the intersection root from the top, so the
      // hero stops "intersecting" while ~50% of it is still visible. This makes the
      // sticky CTA appear well before the hero fully scrolls off, removing the empty
      // gap between the hero and the next section.
      { threshold: 0, rootMargin: '-50% 0px 0px 0px' }
    )
    observer.observe(heroEl)
    return () => observer.disconnect()
  }, [isMobile])

  if (!isMobile) return null

  return (
    <Box
      position="fixed"
      left="10px"
      right="10px"
      bottom="max(10px, env(safe-area-inset-bottom))"
      zIndex={50}
      pointerEvents={visible ? 'auto' : 'none'}
      opacity={visible ? 0.95 : 0}
      transform={visible ? 'translateY(0)' : 'translateY(20px)'}
      transition="opacity 0.2s ease, transform 0.2s ease"
    >
      <Link href={`/onboarding/weight_loss/${ONBOARDING_INITIAL_STEP}`} _hover={{ textDecoration: 'none' }}>
        <Button
          w="full"
          h="auto"
          px="24px"
          py="22px"
          borderRadius="24px"
          bg="#4774B8"
          color="alabaster"
          boxShadow="0 12px 32px rgba(0,0,0,0.55), 0 0 0 1px rgba(255,255,255,0.08), inset 0 1px 0 rgba(255,255,255,0.2)"
          _hover={{ bg: '#5A8AD4' }}
        >
          <Flex w="full" justify="space-between" align="center">
            <Body1
              fontWeight={800}
              fontSize="19px"
              sx={{ fontFeatureSettings: "'ss01' on, 'liga' off, 'calt' off" }}
              letterSpacing="-0.01em"
              lineHeight="1.4rem"
            >
              Começar agora
            </Body1>
            <ArrowRightOmens
              fill="alabaster"
              boxSize="20px"
              sx={{ animation: `${arrowNudge} 2.2s ease-in-out infinite` }}
            />
          </Flex>
        </Button>
      </Link>
    </Box>
  )
}

export default MedleveStickyCTA
